import React from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from '../../../../../components/Header'

export const Title: React.FC = () => {
  const { t } = useTranslation('eInvoiceCockpit')

  return <Header title={t('title.title')} />
}
